// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__24qZa","containerItemsCenter":"Skeleton_containerItemsCenter__UbLOM"};